<template>
  <div class="go-abroad-block">
    <div class="banner">
      <div class="container-block">
        <div class="info">
          <h1>积分明细</h1>
          <p>科研圈内人--让科研人员专注于科学本身！</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{total}}</p>
        </div>
      </div>
    </div>

    <Breadcrumb />

    <div class="container-block">
      <div class="card-block">
        <div class="title">
          <img src="@/assets/imgs/icon35.png" />
          <span>积分明细--当前积分总数：{{pointsTotal}}</span>
        </div>
        
        <el-table :data="tableData" v-loading="tableLoading">
          <el-table-column label="创建时间" prop="creation_time"></el-table-column>
          <el-table-column label="积分数" prop="num"></el-table-column>
          <el-table-column label="来源" prop="desc"></el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <NewPagination
          :current-page.sync="pageparm.page"
          :limit.sync="pageparm.size"
          :total="pageparm.total"
          @pagination="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 积分明细
 */
import * as api from '@/api/user'
import Breadcrumb from '@/components/Breadcrumb'
// 封装的分页组件
import NewPagination from '@/components/Pagination/index'

export default {
  name: 'PointsHistory',
  components: {
    Breadcrumb,
    NewPagination,
  },
  data() {
    return {
      pointsTotal: 0, // 积分总数
      total: 0, // 订单总量
      // 分页参数
      pageparm: {
        page: 1,
        size: 10,
        total: 10,
      },
      tableData: [],
      tableLoading: false,
    }
  },
  created() {

    const _userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.pointsTotal = _userInfo.point || 0

    this.getOrderTotal() //获取订单总数

    this.getListByPage() // 获取积分明细
  },
  methods: {
    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data
          
          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 获取积分明细列表
     */
    getListByPage() {
      const _this = this
      _this.tableLoading = true
      const _param = {
        page: _this.pageparm.page,
        limit: _this.pageparm.size,
      }
      api.pointList(_param)
        .then(res => {
          const _data = res.data
          _this.tableLoading = false
          _this.tableData = _data.list
          _this.pageparm.total = _data.count
        })
        .catch(err => {
          console.log(err)
          _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 页码切换
     * @param {val} 页码
     */
    handleCurrentChange(val) {
      const _this = this
      _this.pageparm.page = val.page
      _this.pageparm.size = val.limit
      _this.getListByPage()
    },
  },
}
</script>
<style lang="scss" scoped>
.go-abroad-block {
  .banner {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../assets/imgs/banner1.png');
    height: 336px;
    color: #ffffff;

    p {
      font-size: 18px;
    }

    .container-block {
      height: 336px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info {
      color: #ffffff;
      margin-left: 60px;

      h1 {
        font-size: 38px;
      }
    }

    .order {
      margin-right: 220px;
    }
  }

  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 20px 0 0 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }
    }

    /deep/.el-table {
      // padding: 0 20px;
      margin-top: 20px;

      th {
        font-size: 19px;
      }

      a {
        color: $colorNormal;
      }

    }

    .pagination-container {
      text-align: right;
    }
  }
}
</style>